module.exports = __webpack_public_path__ + "static/info-page-foto-c0d2e9bdb48ec5f2bff360a16d77acf6.jpg";